<template>
  <article class="WhoWeAre">
    <header-background
      :image-src="headerImageSrc"
      class="WhoWeAre-Banner"
      title="Quem somos"
    />

    <the-title class="WhoWeAre-Title">Sobre nós</the-title>

    <p class="WhoWeAre-Paragraph">
      Nossa história teve início com um propósito claro: atender as reais necessidades de nossos clientes. Desde o primeiro dia, nossa principal meta tem sido trazer soluções especializadas por meio de profissionais com vasta experiência em diversas áreas do conhecimento, tais como Administração, Assistência Social, Educação, Gestão da Qualidade e Produtividade, Gestão de Pessoas e Saúde, tanto em empresas públicas como privadas.
    </p>

    <p class="WhoWeAre-Paragraph">
      Fundada em 02 de março de 2011, a empresa nasceu com o compromisso de oferecer serviços de excelência, confiáveis e sólidos, ao mesmo tempo em que impulsionamos o desenvolvimento integral, tanto individual quanto coletivo. Nossos princípios têm sido os pilares que nos sustentam e continuam a guiar nossas ações diárias, fortalecendo nossa cultura organizacional.
    </p>

    <p class="WhoWeAre-Paragraph">
      Temos gratidão por todas as pessoas que fizeram e fazem parte de nossa história. Olhamos para o futuro com entusiasmo. Estamos comprometidos em continuar construindo um legado de sucesso, sendo protagonistas de uma jornada que transforma o desenvolvimento integral de pessoas e organizações.
    </p>

    <p class="WhoWeAre-Subtitle">
      Nossa Missão
    </p>

    <p class="WhoWeAre-Paragraph">
      Oferecer excelência nos serviços prestados, colocando o sucesso de nossos clientes como nossa principal meta. Construir parcerias sólidas e duradouras.
    </p>

    <p class="WhoWeAre-Subtitle">
      Nossa Visão
    </p>

    <p class="WhoWeAre-Paragraph">
      Ser referência no mercado de trabalho no segmento de atuação e ser a primeira escolha pelas organizações e seus profissionais.
    </p>

    <p class="WhoWeAre-Subtitle">
      Nossos Valores
    </p>

    <p class="WhoWeAre-Paragraph">
      <b>Comprometimento</b> em tudo o que fazemos.<br/>
      <b>Respeito aos nossos clientes</b> na tomada de todas as decisões e ações.<br/>
      <b>Integridade</b>, honestidade, ética e transparência.<br/>
      <b>Atualização permanente</b> de conhecimentos e práticas para o crescimento contínuo e sustentável através da inovação.<br/>
      <b>Responsabilidade Social e Ambiental</b> contribuindo positivamente para a sociedade e o meio ambiente, adotando práticas sustentáveis e apoiando iniciativas sociais.<br/>
      <b>Valorização das Pessoas</b>, bem-estar da nossa equipe, incentivando um ambiente de trabalho colaborativo e respeitoso, possibilitando que todos prosperem e alcancem seu potencial máximo.
    </p>
  </article>
</template>

<style lang="scss" scoped>
  @import "~@/styles/_variables.scss";

  .WhoWeAre {
    width: 100%;

    &-Banner {
      margin-bottom: 10px;
    }

    &-Title {
      margin: 15px 20px;
    }

    &-Paragraph {
      margin: 15px 30px;
      text-align: justify;
    }

    &-Subtitle {
      margin: 15px 30px;
      font-weight: bold;
      font-size: 20px;
    }

    &-List {
      margin: 15px 30px;
    }
  }
</style>

<script>
  import HeaderBackground from "@/components/HeaderBackground";
  import TheTitle from "@/components/TheTitle";

  export default {
    name: "WhoWeAre",

    components: {
      HeaderBackground,
      TheTitle,
    },

    data() {
      return {
        headerImageSrc: "/img/backgrounds/csc-03.jpg",
      };
    },

    mounted() {},
  };
</script>
